module.exports = __webpack_public_path__ + "media/images/gallery/stories_on-f012eabd37fb66a57705ecc6b5712d4a.gif";